// Existing bookings may have an address without stored coordinates.
export const hasMeetingLocation = (address) =>
  typeof address === 'string' && address.trim().length > 0 && address.trim() !== 'Meeting Point';
